import { DocumentData, SnapshotOptions, FirestoreDataConverter, QueryDocumentSnapshot, WithFieldValue } from "firebase/firestore";
import { QuotitHealthPlanDetails } from "services/Interfaces";

export const QuotitPlanConverter: FirestoreDataConverter<QuotitHealthPlanDetails> = {
  toFirestore(plan: WithFieldValue<QuotitHealthPlanDetails>): DocumentData {
    return { ...plan };
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions
  ): QuotitHealthPlanDetails {
    const data = snapshot.data(options);
    if (!data.recommendation) {
      data.recommendation = {};
    }
    return {
      id: data.id,
      benefitLevel: data.benefitLevel,
      benefitsLink: data.benefitsLink,
      providerLink: data.providerLink,
      summaryOfBenefitsLink: data.summaryOfBenefitsLink,
      exclusionsLink: data.exclusionsLink,
      disclaimer: data.disclaimer,
      rate: data.rate,
      premium: data.premium,
      state: data.state,
      premiumSubsidized: data.premiumSubsidized,
      rateSubsidized: data.rateSubsidized,
      onMarket: data.onMarket,
      offMarket: data.offMarket,
      deductible: data.deductible,
      moop: data.moop,
      name: data.name,
      carrierId: data.carrierId,
      effectiveDate: data.effectiveDate,
      rating: data.rating,
      contractStatus: data.contractStatus,
      visibility: data.visibility,
      source: data.source,
      ratingMethod: data.ratingMethod,
      baseRateUnit: data.baseRateUnit,
      carrier: { name: data.carrier.name, logo: data.carrier.logo, largeLogo: data.carrier.largeLogo },
      insuranceType: data.insuranceType,
      planType: data.planType,
      benefits: data.benefits,
      recommendation: {
        internalScore: data.recommendation.internalScore,
        aiScore: data.recommendation.aiScore,
        headline: data.recommendation.headline,
        explanation: data.recommendation.explanation,
        pros: data.recommendation.pros,
        cons: data.recommendation.cons
      },
      memberRates: data.memberRates,
    };
  },
};